import React, { useEffect } from 'react';

import './SkipNavigationLink.scss';

const SkipNavigationLink = () => {
    useEffect(() => {
        if (!document.querySelector('#maincontent')) {
            document.body.querySelector('main')?.setAttribute('id', 'maincontent');
        }
    }, []);
    return (
        <a className="sgw-skip-link" href="#maincontent">
            Hopp til innholdet
        </a>
    );
};

export default SkipNavigationLink;
